const clamp=(v,a,b)=>Math.max(a,Math.min(b,v));
// A cracked wax shard pops off the filling within a few frames, pivots on one
// edge and settles. Every fourth shard is loose and drops to the floor; the
// rest stay near the soft filling so the toy keeps its broken-shell shape.
export function waxFragmentPose(index,age,rest,current,floorY=0,origin=[0,.83,0],profile={loose:4,travel:1,spin:1}){
 const seed=((index*73+19)%101)/101,t=clamp(age/.34,0,1),pop=1-(1-t)**4;
 const loose=index%profile.loose===0;
 const away=rest.map((n,a)=>n-origin[a]),length=Math.hypot(...away)||1,out=away.map(n=>n/length);
 const travel=(loose?.10+.16*seed:.035+.06*seed)*profile.travel;
 const target=current.map((n,a)=>n+out[a]*travel*pop);
 if(loose)target[1]=Math.max(floorY+.025,target[1]-1.9*t*t);
 return {center:target,rotation:[(seed-.5)*2.4*pop*profile.spin,(index%2?1:-1)*(.5+.7*seed)*pop*profile.spin,(.3-seed)*1.4*pop*profile.spin],scale:1-.08*pop};
}
// Pieces near the finger shudder while the shell is loading, then snap.
export function waxTremble(index,time,charge,distance){
 const amp=.012*charge*charge*clamp(1-distance/.9,0,1);
 return [amp*Math.sin(time*61+index*2.1),amp*Math.sin(time*73+index*1.3),amp*Math.sin(time*67+index*.7)];
}
